(function() {

    var chatWidgetFactory = function() {
        // declare factory variables
        var frmObject = {};
        // define factory
        var factory = {
            setFrmObject: function (obj) {
                frmObject = obj;
            },

            getFrmObject: function () {
                return frmObject;
            },
        };

        return factory;
    };

    SUGApp.factory('chatWidgetFactory', chatWidgetFactory);

}());

(function() {

    var chatWidgetService = function( SUGUtilities, $window, globalService, $q ) {

        // define service
        var service = {
            // use this to check if the server response is invalid
            ajaxResultInvalid: function (result) {
                return (typeof result.data === 'undefined' || !result.data.SUCCESS);
            },

            // use this if you just need to get the error message from the server response
            getAjaxResponseMessage: function (result) {
                if (typeof result.data !== 'undefined') {
                    return SUGUtilities.resultErrorHandler(result.data);
                } else {
                    return '';
                }
            },

            // use this for displaying an error modal
            errorHandler: function (errorObj) {
                var errMessage = SUGUtilities.resultErrorHandler(errorObj);
                if (errMessage.indexOf('Make sure you are logged in and have an active session.') >= 0) {
                    $window.location.reload();
                    return;
                }
                // no longer logged in
                if(errorObj.CODE && errorObj.CODE === 1002){
                    $window.location.reload();
                    return;
                } else {
                    SUGUtilities.showMagnificAlert(errMessage, 'error', '', 'Sorry!');
                }
            },

            showChatWidget: function( data ){
                return SUGUtilities.APISyncCall("post", "", data, "t.showChatWidget", 15000);
            },
            getChatWidgetByName: function( data ){
                return SUGUtilities.APISyncCall("post", "", data, "t.getChatWidgetByName", 15000);
            },
            recordChatHistory: function( data ){
                return SUGUtilities.APISyncCall("post", "", data, "t.recordChatHistory", 15000);
            },
            getChatWidgetIdByName: function( data ){
                return SUGUtilities.APISyncCall("post", "", data, "t.getChatWidgetIdByName", 15000);
            },
            getMemberInfo: function( data ){
                return SUGUtilities.APISyncCall("post", "", data, "m.getMemberInfo", 15000);
            }
        };

        return service;
    };

    chatWidgetService.$inject = ['SUGUtilities', '$window', 'globalService', '$q'];

    SUGApp.service('chatWidgetService', chatWidgetService);

}());
